var Cookies = require('js-cookie');

const storedLights = Cookies.get('lights');
const storedGridMode = Cookies.get('gridMode'); 
const storedAutoSave = Cookies.get('autoSave'); 
const storedRecentPatterns = Cookies.get('showRecentPatterns'); 

export const globalReducer = (state = {
  lights: (storedLights === 'undefined' || storedLights === undefined) ? true : JSON.parse(storedLights),
  gridMode: storedGridMode === undefined ? 4 : JSON.parse(storedGridMode),
  autoSave: storedAutoSave === undefined ? false : JSON.parse(storedAutoSave),
  showRecentPatterns: storedRecentPatterns === undefined ? false : JSON.parse(storedRecentPatterns),
  // quadView: ['Hybrid Editor','.PAT Text', 'Calculator', '.PAT Preview'],
  dxfGeneratorOpen: false,
  loginModalOpen: false,
  fullScreen: false,
  gridLines: true,
  zoomControls: true,
  colors: true,
  errors: false,
  trayOpen: {
    library: false,
    calculators: false,
    saved: false
  },
  lockedFeatureModal: {}
}, action) => {

  switch(action.type){
    case 'TOGGLE_LIGHTS':

      var newLights = action.data;

      return {
        ...state,
        lights: newLights
      }


    case 'SHOW_LOCKED_FEATURE_MODAL':

      return {
        ...state,
        lockedFeatureModal: {
          open: true,
          feature_name: action.data
        }
      }

    case 'HIDE_LOCKED_FEATURE_MODAL':

      return {
        ...state,
        lockedFeatureModal: {
          open: false,
          feature_name: undefined
        }
      }

    case 'SET_GRID_MODE':

      var newMode = action.data;

      return {
        ...state,
        gridMode: newMode
      }

    case 'SET_DISPLAY_ZOOM_CONTROLS':

      return {
        ...state,
        zoomControls: action.data
      }
      

    case 'SET_DISPLAY_GRID_LINES':

      return {
        ...state,
        gridLines: action.data
      }
      

    case 'SET_DISPLAY_COLORS':

      return {
        ...state,
        errors: action.data ? false : state.errors,
        colors: action.data
      }
      

    case 'SET_DISPLAY_RULERS':

      return {
        ...state,
        rulers: action.data
      }

    case 'SET_DISPLAY_ERRORS':

      return {
        ...state,
        colors: action.data ? false : state.colors,
        errors: action.data
      }
      


    case 'SET_TRAY_OPEN':

      var trayStatus = state.trayOpen;
      for(var i in trayStatus){
        trayStatus[i] = false;
      }
      trayStatus[action.data.tray] = action.data.open;

      return {
        ...state,
        trayOpen: trayStatus
      }


    case 'SET_DXF_GENERATOR_OPEN':

      return {
        ...state,
        dxfGeneratorOpen: action.data
      }


    case 'SET_LOGIN_MODAL_OPEN':

      return {
        ...state,
        loginModalOpen: action.data
      }


    case 'SET_TEMPLATE_MODAL_OPEN':

      return {
        ...state,
        templateModalOpen: action.data
      }


    case 'SET_DOWNLOAD_MODAL_OPEN':

      return {
        ...state,
        downloadModalOpen: action.data
      }


    case 'SET_SCALE_MODAL_OPEN':

      return {
        ...state,
        scaleModalOpen: action.data
      }


    case 'SET_ROTATE_MODAL_OPEN':

      return {
        ...state,
        rotateModalOpen: action.data
      }


    case 'SET_IMAGE_EXPORT_MODAL_OPEN':

      return {
        ...state,
        imageExportModalOpen: action.data
      }


    case 'SET_JDI_SETTINGS_MODAL_OPEN':

      return {
        ...state,
        jdiSettingsModalOpen: action.data
      }

    case 'SET_AUTO_SAVE':

      return {
        ...state,
        autoSave: action.data
      }


    case 'SET_FULL_SCREEN':

      return {
        ...state,
        fullScreen: action.data
      }
    
    case 'SET_MOBILE_PREVIEW':

      return {
        ...state,
        mobilePreview: action.data,
        fullScreen: action.data,
      }

    case 'SET_QUAD_VIEW':

      var qv = state.quadView;
      qv[action.data.index] = action.data.view;

      return {
        ...state,
        quadView: qv
      }

    case 'SET_RECENT_PATTERNS':

      return {
        ...state,
        showRecentPatterns: action.data
      }
      
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducers.globalReducer.js